<template>
  <v-container class="formulario-wrapper pt-6 mx-auto" fluid style="background-color: #f4f7f6; min-height: 100vh; max-width: 560px !important;">
    <v-card class="elevation-2">

      <v-card-text>
        <v-form ref="form">

          <v-row>
            <v-col cols="12">
              <v-text-field
                :value="nroOSExibicao"
                label="Número da O.S."
                outlined dense hide-details readonly background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-0">
              <core-date-picker-field 
                v-model="formData.dataAbertura"
                label="Data Abertura"
                outlined
                dense 
                hide-details
                clearable
              />
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                :value="totalProduto"
                label="Total do Produto"
                type="number"

                outlined dense hide-details readonly background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                :value="totalServico"
                label="Total do Serviço"
                type="number"

                outlined dense hide-details readonly background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="py-4">
              <v-text-field
                :value="totalOS"
                label="Total da O.S."
                type="number"

                outlined dense hide-details readonly background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-3 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-account-outline</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              CLIENTE
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          <v-row align="center">
            <v-col cols="4">
              <v-text-field 
                v-model.number="formData.cliente" 
                label="Código" 
                outlined dense hide-details 
                type="number"
                min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('cliente')"
                @change="buscarCliente($event)"
                :error="['Cliente não encontrado', 'Erro no Banco'].includes(formData.nomeCliente)"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="d-flex justify-center">
              <v-btn fab small color="primary" elevation="1" @click="pesquisarCliente" >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="7">
              <v-text-field 
                v-model="formData.nomeCliente" 
                label="Nome do Cliente" 
                outlined dense hide-details readonly background-color="#FFF9C4"
                :error="['Cliente não encontrado', 'Erro no Banco'].includes(formData.nomeCliente)"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-3 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-account-wrench-outline</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              RECEBIDO POR
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          <v-row align="center">
            <v-col cols="4">
              <v-text-field 
                v-model.number="formData.codRecebidoPor" 
                label="Código" 
                outlined dense hide-details 
                type="number"
                min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('codRecebidoPor')"
                @change="buscarRecebidoPor($event)"
                :error="['Técnico não encontrado', 'Erro no Banco'].includes(formData.nomeRecebidoPor)"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="d-flex justify-center">
              <v-btn fab small color="primary" elevation="1" @click="pesquisarRecebidoPor">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="7">
              <v-text-field 
                v-model="formData.nomeRecebidoPor" 
                label="Nome do Técnico" 
                outlined dense hide-details readonly background-color="#FFF9C4"
                :error="['Técnico não encontrado', 'Erro no Banco'].includes(formData.nomeRecebidoPor)"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-3 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-account-tie-outline</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              VENDEDOR SERVIÇO
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          <v-row align="center">
            <v-col cols="4">
              <v-text-field 
                v-model.number="formData.codVendedor" 
                label="Código" 
                outlined dense hide-details 
                type="number"
                min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('codVendedor')"
                @change="buscarVendedor($event)"
                :error="['Vendedor não encontrado', 'Erro no Banco'].includes(formData.nomeVendedor)"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="d-flex justify-center">
              <v-btn fab small color="primary" elevation="1" @click="pesquisarVendedor">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="7">
              <v-text-field 
                v-model="formData.nomeVendedor" 
                label="Nome do Vendedor" 
                outlined dense hide-details readonly background-color="#FFF9C4"
                :error="['Vendedor não encontrado', 'Erro no Banco'].includes(formData.nomeVendedor)"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex align-center mt-3 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-domain</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              FORNECEDOR (INDICAÇÃO)
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          <v-row align="center">
            <v-col cols="4">
              <v-text-field 
                v-model.number="formData.idFornecedor" 
                label="Código" 
                outlined dense hide-details 
                type="number"
                min="0"
                @keydown="bloquearCaracteresInvalidos"
                @input="garantirPositivo('idFornecedor')"
                @change="buscarFornecedor($event)"
                :error="['Fornecedor não encontrado', 'Erro no Banco'].includes(formData.nomeFornecedor)"
              ></v-text-field>
            </v-col>
            <v-col cols="1" class="d-flex justify-center">
              <v-btn fab small color="primary" elevation="1" @click="pesquisarFornecedor" >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="7">
              <v-text-field 
                v-model="formData.nomeFornecedor" 
                label="Nome do Fornecedor" 
                outlined dense hide-details readonly background-color="#FFF9C4"
                :error="['Fornecedor não encontrado', 'Erro no Banco'].includes(formData.nomeFornecedor)"
              ></v-text-field>
            </v-col>
          </v-row>

          
          <template v-if="exibirSecaoTecnicoVerificacao">
            <div class="d-flex align-center mt-3 mb-2">
              <v-icon small color="primary" class="mr-2">mdi-account-check-outline</v-icon>
              <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
                TÉCNICO VERIFICAÇÃO
              </span>
              <v-divider class="ml-3 divisor-secao"></v-divider>
            </div>
            <v-row align="center">
              <v-col cols="4">
                <v-text-field 
                  v-model.number="formData.codTecnicoVerificacao" 
                  label="Código" 
                  outlined dense hide-details 
                  type="number"
                  min="0"
                  @keydown="bloquearCaracteresInvalidos"
                  @input="garantirPositivo('codTecnicoVerificacao')"
                  @change="buscarTecnicoVerificacao($event)"
                  :error="['Técnico não encontrado', 'Erro no Banco'].includes(formData.nomeTecnicoVerificacao)"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="d-flex justify-center">
                <v-btn fab small color="primary" elevation="1" @click="pesquisarTecnicoVerificacao">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="7">
                <v-text-field 
                  v-model="formData.nomeTecnicoVerificacao" 
                  label="Nome do Técnico" 
                  outlined dense hide-details readonly background-color="#FFF9C4"
                  :error="['Técnico não encontrado', 'Erro no Banco'].includes(formData.nomeTecnicoVerificacao)"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>

          <v-divider class="my-4 divisor-secao"></v-divider>

          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="formData.defeitoApresentado"
                label="Defeito Apresentado"
                outlined
                hide-details
                rows="3"
                background-color="lighten-5"
              ></v-textarea>
            </v-col>
          </v-row>

          <!-- <v-divider class="my-4 divisor-secao"></v-divider> -->

          <v-row>
            <v-col cols="12" class="py-0">
              <v-checkbox
                v-model="mostrarObservacao"
                label="Adicionar observação"
                hide-details
                dense
                class="mt-0"
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row v-if="mostrarObservacao" class="mt-2">
            <v-col cols="12">
              <v-textarea
                v-model="formData.observacao"
                label="Observação"
                outlined
                hide-details
                rows="3"
                background-color="lighten-5"
              ></v-textarea>
            </v-col>
          </v-row>
          
          <template v-if="exibirSecaoVeiculo">

          <div class="d-flex align-center mt-6 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-car-back </v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              VEICULO
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
            
            <v-row align="center">
              <v-col cols="6">
                <v-text-field 
                  v-model="formData.placa" 
                  v-mask="'XXX-XXXX'"
                  label="Placa" 
                  outlined dense hide-details 
                  @input="formData.placa = (formData.placa || '').toUpperCase()"
                  @keydown.enter="buscarVeiculoPorPlacaOS"
                  @blur="buscarVeiculoPorPlacaOS"
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="d-flex justify-center">
                <v-btn fab small color="primary" elevation="1" @click="pesquisarPlaca" title="Pesquisar Veículo">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="5" class="d-flex justify-center">
                <v-btn color="primary" outlined @click="abrirCadastroVeiculo">
                  <v-icon left>mdi-car</v-icon>
                  Veículo
                </v-btn>
              </v-col>
            </v-row>
          </template>

          <template v-if="exibirSecaoEquipamento">
            <div class="d-flex align-center mt-6 mb-2">
              <v-icon small color="primary" class="mr-2">mdi-cog</v-icon>
              <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
                EQUIPAMENTO
              </span>
              <v-divider class="ml-3 divisor-secao"></v-divider>
            </div>
            
            <v-row align="center">
              <v-col cols="12" class="d-flex justify-start">
                <v-btn color="primary" outlined @click="abrirCadastroEquipamento">
                  <v-icon left>mdi-cog</v-icon>
                  Equipamento
                </v-btn>
              </v-col>
            </v-row>
          </template>

          <div class="d-flex align-center mt-3 mb-2">
            <v-icon small color="primary" class="mr-2">mdi-format-list-bulleted</v-icon>
            <span class="font-weight-bold text-subtitle-2 primary--text text--darken-1">
              ITENS DO CADASTRO
            </span>
            <v-divider class="ml-3 divisor-secao"></v-divider>
          </div>
          <v-row>
            <v-col class="d-flex flex-wrap align-center" style="gap: 8px;">
              <v-btn color="primary" @click="adicionarItem">
                <v-icon left>mdi-plus</v-icon>
                Adicionar Item
              </v-btn>
              <v-btn color="blue-grey" outlined @click="abrirAdicionarMidia">
                <v-icon left>mdi-camera-plus</v-icon>
                Mídia
              </v-btn>
            </v-col>
          </v-row>
          
          <v-row class="mt-2" v-if="currentTempMedias && currentTempMedias.length > 0">
            <v-col cols="12" class="py-0">
              <div class="d-flex align-center mt-2 mb-2">
                <v-icon small color="primary" class="mr-2">mdi-camera-outline</v-icon>
                <span class="font-weight-bold text-subtitle-2 primary--text text--darken-2">
                  MÍDIAS DA O.S.
                </span>
                <v-divider class="ml-3 divisor-secao"></v-divider>
              </div>
              <div class="mt-1" style="white-space: nowrap; overflow-x: auto; padding-bottom: 8px;">
                
                <div v-for="(m, i) in currentTempMedias" :key="i" @click="$_abrirMidiaModal(i)" style="position:relative; width:60px; height:60px; margin-right:8px; display:inline-block; border-radius: 4px; overflow: hidden; cursor: pointer;">
                  
                  <img v-if="m.tipo !== 'video'" :src="m.dados" style="width:100%; height:100%; object-fit:cover;" />
                  
                  <div v-else style="position: relative; height: 100%; width: 100%;">
                    <video style="width: 100%; height: 100%; object-fit: cover;">
                      <source :src="m.dados" type="video/mp4" />
                    </video>
                    <div class="d-flex align-center justify-center" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.2);">
                      <v-icon color="white" size="24">mdi-play-circle-outline</v-icon>
                    </div>
                  </div>
                  
                </div>
              </div>
            </v-col>
          </v-row>
          
          <v-row v-if="itensPedido.length > 0" class="mt-4">
            <v-col cols="12" class="py-0">
              <simplebar
                data-simplebar
                :autoHide="false"
                class="lista-itens-container elevation-1"
              >
                <v-list class="py-0" flat>
                  <template v-for="(item, index) in itensPedido">
                    <v-list-item 
                      :key="item.id" 
                      class="px-3"
                      @click="editarItem(item)"
                    >
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold">
                          {{ item.codigo }} {{ item.descricao ? ' - ' + item.descricao : '' }}
                          <span v-if="item.observacao"> - {{ item.observacao }}</span>
                        </v-list-item-title>

                        <v-list-item-subtitle class="mt-1">
                          Qtd: {{ item.quantidade }} | 
                          Preço: {{ formatarValor(item.valorunitario) }}
                        </v-list-item-subtitle>

                        <v-list-item-subtitle class="font-weight-medium">
                          Total: <span> {{ formatarValor(item.subtotal) }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-icon color="grey">mdi-chevron-right</v-icon>
                      </v-list-item-action>
                      
                    </v-list-item>

                    <v-divider v-if="index < itensPedido.length - 1" :key="`divider-${index}`"></v-divider>
                    
                  </template>
                </v-list>
              </simplebar>
            </v-col>
          </v-row>

        </v-form>
      </v-card-text>

      <v-divider class="my-0 divisor-secao"></v-divider>

      <v-card-actions class="pa-4">
        <v-row>
          <v-col cols="4" class="text-left">
            <v-btn color="error" outlined @click="excluir" v-if="pedidoDexieId && !pedidoEnviado">Excluir</v-btn>
          </v-col>
          <v-col cols="4" class="text-center">
            <v-btn text @click="cancelar" outlined>Cancelar</v-btn>
          </v-col>
          <v-col cols="4" class="text-right">
            <v-btn color="primary" @click="salvar">Salvar</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

      <v-dialog v-model="dialogValidacao" max-width="400">
      <v-card>
        <v-card-title class="headline primary white--text text--darken-2">
          Atenção
        </v-card-title>
        
        <v-card-text class="pt-4 body-1 black--text">
          Não foi possível salvar o pedido. Verifique os seguintes itens:
          
          <ul class="mt-3 ml-2">
            <li v-for="(campo, index) in camposInvalidos" :key="index" class="red--text text--darken-3">
              {{ campo }}
            </li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" class="primary" text @click="dialogValidacao = false">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmarExclusao" max-width="400">
      <v-card>
        <v-card-title class="headline text-h6 primary white--text text--darken-2">Confirmar Exclusão</v-card-title>
        <v-card-text class="pt-4 body-1 black--text">
          Deseja realmente excluir esta O.S.? Esta ação não poderá ser desfeita.
        </v-card-text>
        <v-card-actions class="pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn text @click="dialogConfirmarExclusao = false">Não</v-btn>
          <v-btn color="primary" @click="confirmarExclusao" elevation="0">Sim, Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmarCancelamento" max-width="400">
      <v-card>
        <v-card-title class="headline text-h6 primary white--text text--darken-2">Confirmar Cancelamento</v-card-title>
        <v-card-text class="pt-4 body-1 black--text">
          Deseja realmente cancelar? Todas as alterações não salvas serão perdidas.
        </v-card-text>
        <v-card-actions class="pb-4 pr-4">
          <v-spacer></v-spacer>
          <v-btn text @click="dialogConfirmarCancelamento = false">Não</v-btn>
          <v-btn color="primary" @click="confirmarCancelamento" elevation="0">Sim, Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogClienteObrigatorio" max-width="400">
      <v-card>
        <v-card-title class="headline primary white--text text--darken-2">
          Atenção
        </v-card-title>
        
        <v-card-text class="pt-4 body-1 black--text">
          Por favor, selecione um cliente válido antes de adicionar itens à O.S.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogClienteObrigatorio = false">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para informar veículo não encontrado e sugerir cadastro -->
    <v-dialog v-model="dialogVeiculoNaoEncontrado" max-width="450">
      <v-card class="rounded-lg">
        <v-card-title class="teste headline white--text text--darken-2 d-flex align-center">
          <v-icon color="white" class="mr-2" size="28">mdi-alert-circle-outline</v-icon>
          Veículo Não Encontrado
        </v-card-title>

        <v-card-text class="pt-4 body-1 black--text">
          A placa <strong>{{ placaNaoEncontrada }}</strong> não está cadastrada no sistema.
          <br /><br />
          Deseja cadastrar um novo veículo com esta placa?
        </v-card-text>

        <v-card-actions class="pb-4 px-4">
          <v-spacer></v-spacer>
          <v-btn color="black lighten-1" text @click="cancelarDialogVeiculoNaoEncontrado">
            Cancelar
          </v-btn>
          <v-btn color="primary" elevation="1" @click="confirmarCadastroNovoVeiculo">
            Cadastrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog para alterar vínculo do cliente no veículo -->
    <v-dialog v-model="dialogTrocarClienteVeiculo" max-width="480" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="teste headline white--text text--darken-2 d-flex align-center">
          <v-icon color="white" class="mr-2" size="28">mdi-account-switch</v-icon>
          Veículo vinculado a outro cliente
        </v-card-title>

        <v-card-text class="pt-4 body-1 black--text" v-if="veiculoPendenteTrocaCliente">
          O veículo <strong>{{ veiculoPendenteTrocaCliente.placa }} - {{ veiculoPendenteTrocaCliente.descricao }}</strong> está vinculado ao cliente <strong>{{ veiculoPendenteTrocaCliente.nomeClienteVeiculo }}</strong>.
          <br /><br />
          Deseja alterar o vínculo deste veículo para o cliente atual <strong>{{ veiculoPendenteTrocaCliente.nomeClienteAtualOS }}</strong>?
        </v-card-text>

        <v-card-actions class="pb-4 px-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="recusarTrocaClienteVeiculo">
            Não
          </v-btn>
          <v-btn color="primary" elevation="1" @click="confirmarTrocaClienteVeiculo">
            Sim, Alterar Vínculo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Bottom sheet para adicionar imagens -->
    <v-bottom-sheet v-model="imagemDialog">
      <v-card class="rounded-t-xl">
        <div class="d-flex justify-center pt-3 pb-1">
          <div style="width: 40px; height: 4px; background-color: #e0e0e0; border-radius: 2px;"></div>
        </div>

        <v-card-title class="headline d-flex justify-space-between align-center px-6 pt-2 pb-2">
          <div class="d-flex align-center">
            <v-icon color="#4c6faf" class="mr-2">mdi-camera-plus-outline</v-icon>
            <span class="font-weight-bold" style="color: #4c6faf; font-size: 1.25rem;">Gerenciar Mídia da O.S.</span>
          </div>
          <v-btn icon color="grey darken-1" small @click="fecharAdicionarMidia" aria-label="Fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="px-6 pt-2 pb-4">
          <GerenciadorMidia
            chaveItem="OS_MEDIA"
            :midiasIniciais="currentTempMedias"
            @atualizar:midias="$_onGerenciadorAtualizar"
            @abrirCamera="$_iniciarCamera"
            @abrirModalPreview="$_abrirMidiaModal($event)"
          />
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-0 justify-end">
          <v-btn text color="grey darken-1" class="text-capitalize font-weight-medium px-4" @click="fecharAdicionarMidia">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <!-- Modal para exibir mídia em fullscreen -->
    <v-dialog v-model="midiaModalAberto" fullscreen hide-overlay transition="slide-y-reverse-transition">
      <v-card style="height: 100%; background-color: #000;">
        <v-card-text class="d-flex flex-column justify-center align-center" style="height: 100%; position: relative;">
          
          <v-btn icon large color="white" style="position: absolute; top: 16px; right: 16px; z-index: 10;" @click="$_fecharMidiaModal">
            <v-icon large>mdi-close</v-icon>
          </v-btn>

          <img v-if="midiaModal && midiaModal.tipo === 'image'" :src="midiaModal.dados" class="midia-fullscreen" style="max-width: 90%; max-height: 90%; object-fit: contain;">

          <video v-else-if="midiaModal && midiaModal.tipo === 'video'" ref="videoFullscreen" controls class="midia-fullscreen" style="max-width: 90%; max-height: 90%; object-fit: contain;">
            <source :src="midiaModal.dados" type="video/mp4">
          </video>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-overlay :value="isSalvando" z-index="9999">
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="white"></v-progress-circular>
        <div class="mt-4 font-weight-bold white--text" style="font-size: 1.2rem;">Salvando O.S...</div>
      </div>
    </v-overlay>

  </v-container>
</template>

<script>
import simplebar from 'simplebar-vue';
import 'simplebar-vue/dist/simplebar.min.css';
// import { SetupEnvioLocal } from '@/utils/atualizalocal';
import { USER_STORAGE } from '@/constants/STORAGE';
import CoreDatePickerField from '@/components/core/date-picker-past/Index.vue';
import db from '@/plugins/dexie'; 
import GerenciadorMidia from '@/components/coleta/MediaManager.vue';
import { tempMedia } from '@/utils/tempMedia';
import { geraData } from '@/utils/libutil';
import { ROUTE_CAMERA } from '@/constants/ROUTES';

export default {
  name: 'CadastroOS',
  components: {
    simplebar,
    CoreDatePickerField,
    GerenciadorMidia,
  },
  data() {
    return {
      isRestaurando: false,
      isSalvando: false,
      pedidoDexieId: null, 

      pedidoEnviado: false,
      mostrarObservacao: false,

      dialogValidacao: false,
      dialogConfirmarExclusao: false,
      dialogConfirmarCancelamento: false,
      dialogClienteObrigatorio: false,
      dialogVeiculoNaoEncontrado: false,
      dialogTrocarClienteVeiculo: false,
      veiculoPendenteTrocaCliente: null,
      placaNaoEncontrada: '',
      camposInvalidos: [],
      
      imagemDialog: false,
      midiaModalAberto: false,
      midiaModal: null,
      indiceMidiaModal: null,
      arquivosTemp: tempMedia,
      MAX_FILE_SIZE: 10 * 1024 * 1024,

      formData: {
        nroOS: null,
        prsidnuvem: null,
        prslinkpedidoitem: null,
        dataAbertura: new Date().toISOString().substr(0, 10),
        cliente: '',
        nomeCliente: '',
        contato: '',
        idRecebidoPor: '',   
        codRecebidoPor: '',
        nomeRecebidoPor: '', 
        idTecnicoVerificacao: '',
        codTecnicoVerificacao: '',
        nomeTecnicoVerificacao: '',
        idVendedor: '',
        codVendedor: '',
        nomeVendedor: '',
        idFornecedor: '',
        nomeFornecedor: '',
        defeitoApresentado: '',
        observacao: '',
        placa: '',
        veiculo: '',
        idveiculo: null,
        idmarcaveiculo: null,
        km: '',
        motor: '',
        ano: '',
        modelo: '',
        combustivel: '',
        chassi: '',
        numSerie: '',
        prsdescricaoequipamento: '',
        prsmarcaequipamento: '',
        prsnumeroserieequipamento: '',
        prsidentificacaoidsequipamento: '',
        prsdadocomplementar: '',
        prslivre1: '',
        prslivre2: '',
        prslivre3: ''
      },
      
      itensPedido: []
    }
  },

  async created() {
    const idNaRota = this.$route.query.id ? parseInt(this.$route.query.id) : null;
    const temResultadoPesquisa = sessionStorage.getItem('pesquisaResultado') !== null;
    const estadoSalvoString = sessionStorage.getItem('osEmEdicao');
    
    let deveRestaurarSessao = false;

    if (temResultadoPesquisa) {
      deveRestaurarSessao = true;
    } 
    else if (estadoSalvoString) {
      const estado = JSON.parse(estadoSalvoString);
      
      if (idNaRota) {
        if (estado.pedidoDexieId === idNaRota) deveRestaurarSessao = true;
      } else {
        if (!estado.pedidoDexieId) deveRestaurarSessao = true;
      }
    }

    if (!this.$store.getters['empresa/dados']) {
      await this.$store.dispatch('empresa/find').catch((err) => console.error('Erro ao buscar dados da empresa:', err));
    }

    if (deveRestaurarSessao) {
      await this.verificarRetornoPesquisa();
    } else if (idNaRota) {
      this.$set(this.arquivosTemp, 'OS_MEDIA', []);
      await this.carregarOSParaEdicao(idNaRota);
    } else {
      sessionStorage.removeItem('osEmEdicao');
      this.$set(this.arquivosTemp, 'OS_MEDIA', []);
      await this.carregarTecnicoVerificacaoPadrao();
    }
    
    await this.limparItensOrfaos();

    this.$root.$on('appbar-solicita-cancelamento', this.tratarVoltarAppBar);
  },

  beforeDestroy() {
    this.$root.$off('appbar-solicita-cancelamento', this.tratarVoltarAppBar);
  },
  
  activated() {
    this.verificarRetornoPesquisa();
  },

  computed: {
    osPedeTecnicoVerificacao() {
      const val = this.$store.getters['empresa/osPedeTecnicoVerificacao'];
      return val ? String(val).toUpperCase().trim() : 'N';
    },

    exibirSecaoTecnicoVerificacao() {
      return this.osPedeTecnicoVerificacao === 'S';
    },

    osPedeDadosEquipamento() {
      return this.$store.getters['empresa/osPedeDadosEquipamento'];
    },

    exibirSecaoVeiculo() {
      // E = Nenhum (não exibe)
      // N = Veículo (exibe a seção de veículo)
      // S = Equipamento (não exibe a seção de veículo)
      return this.osPedeDadosEquipamento === 'N';
    },

    exibirSecaoEquipamento() {
      // S = Equipamento (exibe a seção de equipamento)
      return this.osPedeDadosEquipamento === 'S';
    },

    nroOSExibicao() {
      const nro = this.formData.nroOS;
      const nuvem = this.formData.prsidnuvem;
      if (nuvem && String(nuvem).trim() !== '' && String(nuvem) !== 'null') {
        return nro ? `${nuvem}` : `${nuvem}`;
      }
      return nro;
    },

    totalProduto() {
      const total = this.itensPedido.reduce((acc, item) => {
        const isServico = item.isServico !== undefined ? item.isServico : (item.idgrupo === 2);
        if (isServico) return acc;
        
        const qtd = parseFloat(item.quantidade) || 0;
        const val = parseFloat(item.valorunitario) || 0; 
        const desc = parseFloat(item.valordesconto) || 0;
        const promo = parseFloat(item.vlrpromocaoclube) || 0;
        
        return acc + ((qtd * (val - desc)) - promo);
      }, 0);
      return total.toFixed(2);
    },

    totalServico() {
      const total = this.itensPedido.reduce((acc, item) => {
        const isServico = item.isServico !== undefined ? item.isServico : (item.idgrupo === 2);
        if (!isServico) return acc;
        
        const qtd = parseFloat(item.quantidade) || 0;
        const val = parseFloat(item.valorunitario) || 0; 
        const desc = parseFloat(item.valordesconto) || 0;
        const promo = parseFloat(item.vlrpromocaoclube) || 0;
        
        return acc + ((qtd * (val - desc)) - promo);
      }, 0);
      return total.toFixed(2);
    },

    totalOS() {
      const total = this.itensPedido.reduce((acc, item) => {
        const qtd = parseFloat(item.quantidade) || 0;
        const val = parseFloat(item.valorunitario) || 0; 
        const desc = parseFloat(item.valordesconto) || 0;
        const promo = parseFloat(item.vlrpromocaoclube) || 0;
        
        return acc + ((qtd * (val - desc)) - promo);
      }, 0);
      return total.toFixed(2);
    },
    
    currentTempMedias() {
      return this.arquivosTemp['OS_MEDIA'] || [];
    }
  },

  methods: {

    async limparItensOrfaos() {
      try {
        const todosItens = await db.prestacaoservicoitem.toArray();

        const idsParaDeletar = todosItens
          .filter(item => {
            if (item.pridatatransmissao) return false;

            const semIdNuvem = !item.priidprestacaoserviconuvem;
            
            const semOSLocal = !item.idprestacaoservico; 
            
            const naoEhDestaOS = item.prilinkpedidoitem !== this.formData.prslinkpedidoitem;

            return semIdNuvem && semOSLocal && naoEhDestaOS;
          })
          .map(item => item.id);

        if (idsParaDeletar.length > 0) {
          await db.prestacaoservicoitem.bulkDelete(idsParaDeletar);
        } else {
          // console.log("Nenhum item órfão encontrado para limpeza.");
        }

      } catch (error) {
        console.error("Erro ao limpar itens órfãos do Dexie:", error);
      }
    },

    async carregarTecnicoVerificacaoPadrao() {
      try {
        let idVendedorLogado = sessionStorage.getItem(USER_STORAGE.useidnuvem);
        let codigoVendedorLogado = null;
        let nomeVendedorLogado = sessionStorage.getItem('user:nomevendedor');

        const param = await db.parametro.toCollection().first().catch(() => null);
        if (param) {
          if (!idVendedorLogado && param.paridvendedorlogado) {
            idVendedorLogado = param.paridvendedorlogado;
          }
          if (param.parvendedorcodigo) {
            codigoVendedorLogado = param.parvendedorcodigo;
          }
          if (!nomeVendedorLogado && param.parvendedornome) {
            nomeVendedorLogado = param.parvendedornome;
          }
        }

        const codigoParaBuscar = codigoVendedorLogado || idVendedorLogado;

        if (codigoParaBuscar) {
          await this.buscarTecnicoVerificacao(codigoParaBuscar);
        }

        if (!this.formData.idTecnicoVerificacao || !this.formData.nomeTecnicoVerificacao || this.formData.nomeTecnicoVerificacao === 'Técnico não encontrado') {
          if (idVendedorLogado) {
            await this.buscarVendedorPorIdNuvem('TecnicoVerificacao', idVendedorLogado);
          }
        }

        if (codigoVendedorLogado && !this.formData.codTecnicoVerificacao) {
          this.formData.codTecnicoVerificacao = parseInt(codigoVendedorLogado) || codigoVendedorLogado;
        }
        if (idVendedorLogado && !this.formData.idTecnicoVerificacao) {
          this.formData.idTecnicoVerificacao = parseInt(idVendedorLogado) || idVendedorLogado;
        }
        if (nomeVendedorLogado && (!this.formData.nomeTecnicoVerificacao || this.formData.nomeTecnicoVerificacao === 'Técnico não encontrado')) {
          this.formData.nomeTecnicoVerificacao = nomeVendedorLogado;
        }
      } catch (error) {
        console.error('Erro ao carregar técnico de verificação padrão:', error);
      }
    },

    async buscarVendedorPorIdNuvem(tipo, idNuvem) {
      if (!idNuvem) return;
      const idNum = parseInt(idNuvem);
      if (isNaN(idNum)) return;
      
      try {
        let vendedor = await db.vendedor.where('venidnuvem').equals(idNum).first();
        if (!vendedor) vendedor = await db.vendedor.where('venidnuvem').equals(String(idNum)).first();

        if (!vendedor) vendedor = await db.vendedor.where('vencodigo').equals(idNum).first();
        if (!vendedor) vendedor = await db.vendedor.where('vencodigo').equals(String(idNum)).first();

        if (!vendedor) vendedor = await db.vendedor.get(idNum);

        const venId = vendedor ? (vendedor.venidnuvem || vendedor.vencodigo || vendedor.id || idNum) : idNum;
        const venCod = vendedor ? (vendedor.vencodigo || idNum) : idNum;
        const venNome = vendedor ? (vendedor.vennome || vendedor.nome || vendedor.descricao) : null;

        if (tipo === 'Vendedor') {
          this.formData.idVendedor = venId;
          this.formData.codVendedor = venCod;
          if (venNome) this.formData.nomeVendedor = venNome;
        } else if (tipo === 'RecebidoPor') {
          this.formData.idRecebidoPor = venId;
          this.formData.codRecebidoPor = venCod;
          if (venNome) this.formData.nomeRecebidoPor = venNome;
        } else if (tipo === 'TecnicoVerificacao') {
          this.formData.idTecnicoVerificacao = venId;
          this.formData.codTecnicoVerificacao = venCod;
          if (venNome) this.formData.nomeTecnicoVerificacao = venNome;
        }
      } catch (error) {
        console.error(`Erro ao buscar ${tipo} pelo ID nuvem ou código:`, error);
      }
    },

    async obterVeiculoPorId(idVei) {
      if (!idVei) return null;
      const idNum = parseInt(idVei);
      if (isNaN(idNum)) return null;

      let v = await db.veiculo.where('veiidveiculo').equals(idNum).first();
      if (!v) {
        v = await db.veiculo.get(idNum);
      }
      if (!v) {
        v = await db.veiculo.where('veiidnuvem').equals(idNum).first();
      }
      return v;
    },

    async carregarOSParaEdicao(id) {
      this.isRestaurando = true;

      try {
        const idNumerico = parseInt(id);
        const os = await db.prestacaoservico.get(idNumerico);

        if (!os) {
          alert('Ordem de serviço não encontrada.');
          return;
        }

        this.pedidoDexieId = os.id || idNumerico;

        this.pedidoEnviado = !!(os.prsdatatransmissao || os.datatransmissao);

        this.formData.nroOS = os.prsidprestacaoservico || null;
        this.formData.prsidnuvem = os.prsidnuvem || null;
        this.formData.dataAbertura = os.prsdatainclusao ? os.prsdatainclusao.substr(0, 10) : new Date().toISOString().substr(0, 10);
        
        this.formData.cliente = os.prsidcliente || '';
        this.formData.nomeCliente = os.prsnomecliente || '';
        if (this.formData.cliente) {
          await this.buscarCliente(this.formData.cliente);
        }
        
        this.formData.idRecebidoPor = os.prsrecebidopor || '';
        this.formData.codRecebidoPor = os.prsrecebidopor || '';

        this.formData.idTecnicoVerificacao = os.prsidtecnicoverificacao || '';
        this.formData.codTecnicoVerificacao = os.prsidtecnicoverificacao || '';

        this.formData.idVendedor = os.prsidvendedor || '';
        this.formData.codVendedor = os.prsidvendedor || '';

        this.formData.idFornecedor = os.prsidfornecedor || '';
        
        this.formData.defeitoApresentado = os.prsdefeito || '';
        this.formData.observacao = os.prsobservacao || '';
        if (this.formData.observacao.trim() !== '') {
          this.mostrarObservacao = true;
        }
        this.formData.prslinkpedidoitem = os.prslinkpedidoitem || null;

        this.formData.idveiculo = os.prsidveiculo || null;
        this.formData.idmarcaveiculo = os.prsidmarcaveiculo || null;
        this.formData.km = os.prskm || '';
        this.formData.motor = os.prsmotor || '';
        this.formData.ano = os.prsanoveiculo || '';
        this.formData.modelo = os.prsanomodeloveiculo || '';
        this.formData.combustivel = os.prscombustivel || '';
        this.formData.chassi = os.prsnumerochassi || '';
        this.formData.numSerie = os.prsnumeroserieequipamento || os.numSerie || '';

        this.formData.prsdescricaoequipamento = os.prsdescricaoequipamento || os.DESCRICAOEQUIPAMENTO || os.DescricaoEquipamento || '';
        this.formData.prsmarcaequipamento = os.prsmarcaequipamento || os.MARCAEQUIPAMENTO || os.MarcaEquipamento || '';
        this.formData.prsnumeroserieequipamento = os.prsnumeroserieequipamento || os.NUMEROSERIEEQUIPAMENTO || os.NumeroSerieEquipamento || os.numSerie || '';
        this.formData.prsidentificacaoidsequipamento = os.prsidentificacaoidsequipamento || os.IDENTIFICACAOIDSEQUIPAMENTO || os.IdentificacaoIDSEquipamento || '';
        this.formData.prsdadocomplementar = os.prsdadocomplementar || os.DadoComplementar || os.dadocomplementar || '';
        this.formData.prslivre1 = os.prslivre1 || os.Livre1 || os.livre1 || '';
        this.formData.prslivre2 = os.prslivre2 || os.Livre2 || os.livre2 || '';
        this.formData.prslivre3 = os.prslivre3 || os.Livre3 || os.livre3 || '';

        if (os.prsidveiculo) {
          let vei = await this.obterVeiculoPorId(os.prsidveiculo);
          if (vei) {
            this.formData.placa = vei.veiplaca || vei.placa || this.formData.placa || '';
            this.formData.veiculo = vei.veidescricao || vei.descricao || this.formData.veiculo || '';
            if (!this.formData.idmarcaveiculo) this.formData.idmarcaveiculo = vei.veiidmarca || vei.IDMARCA || vei.idmarcaveiculo || null;
            if (!this.formData.km) this.formData.km = vei.veikm || vei.km || '';
            if (!this.formData.motor) this.formData.motor = vei.veimotor || vei.motor || '';
            if (!this.formData.ano) this.formData.ano = vei.veiano || vei.ano || '';
            if (!this.formData.modelo) this.formData.modelo = vei.veianomodelo || vei.modelo || '';
            if (!this.formData.combustivel) this.formData.combustivel = vei.veicombustivel || vei.combustivel || '';
            if (!this.formData.chassi) this.formData.chassi = vei.veichassi || vei.chassi || '';
            if (!this.formData.numSerie) this.formData.numSerie = vei.veinumeroserie || vei.numSerie || '';
          }
        }

        if (this.formData.idRecebidoPor) await this.buscarVendedorPorIdNuvem('RecebidoPor', this.formData.idRecebidoPor);
        if (this.formData.idTecnicoVerificacao) await this.buscarVendedorPorIdNuvem('TecnicoVerificacao', this.formData.idTecnicoVerificacao);
        if (this.formData.idVendedor) await this.buscarVendedorPorIdNuvem('Vendedor', this.formData.idVendedor);
        if (this.formData.idFornecedor) await this.buscarFornecedor(this.formData.idFornecedor);

        await this.carregarItens();
        
        try {
          const imagensDB = await db.imagem.where('relacaoidlocal').equals(this.pedidoDexieId).filter(img => img.relacao === 'prestacaoservico').toArray();
          if (imagensDB && imagensDB.length > 0) {
            if (!tempMedia['OS_MEDIA']) tempMedia['OS_MEDIA'] = [];
            for (const imgDB of imagensDB) {
              const urlBlob = URL.createObjectURL(imgDB.blob);
              const jaExiste = tempMedia['OS_MEDIA'].some(img => img.nomearquivo === imgDB.nomearquivo);
              if (!jaExiste) {
                tempMedia['OS_MEDIA'].push({
                  tipo: imgDB.blob?.type?.startsWith('video') ? 'video' : 'image',
                  dados: urlBlob,
                  nomearquivo: imgDB.nomearquivo,
                  datacriacao: imgDB.datacriacao,
                  dexie: imgDB.id,
                });
              }
            }
          }
        } catch (err) {
          console.error("Erro ao carregar imagens:", err);
        }

      } catch (error) {
        console.error("Erro ao carregar O.S. para edição:", error);
      } finally {
        this.$nextTick(() => {
          this.isRestaurando = false;
        });
      }
    },

    tratarVoltarAppBar() {
      this.cancelar(); 
    },
    // ==========================================
    // MÉTODOS DE VALIDAÇÃO DE INPUT
    // ==========================================
    garantirPositivo(campo) {
      if (this.formData[campo] < 0) {
        this.formData[campo] = Math.abs(this.formData[campo]);
      }
    },

    bloquearCaracteresInvalidos(e) {
      if (['-', '+'].includes(e.key)) {
        e.preventDefault();
      }
    },

    // ==========================================
    // 1. BUSCAS NO BANCO DE DADOS (DEXIE)
    // ==========================================
    async buscarCliente(valor) {
      const idNum = parseInt(valor);
      if (!valor || isNaN(idNum)) {
        this.formData.nomeCliente = '';
        return;
      }
      try {
        let cliente = await db.cliente.where('cliidcliente').equals(idNum).first();
        if (!cliente) cliente = await db.cliente.where('cliidcliente').equals(String(idNum)).first();
        if (!cliente) cliente = await db.cliente.get(idNum);

        if (cliente) {
          this.formData.nomeCliente = cliente.clinome || cliente.nome || cliente.clinomefantasia;

          if (this.formData.idveiculo || this.formData.placa) {
            let vei = await this.obterVeiculoPorId(this.formData.idveiculo);
            if (!vei && this.formData.placa) {
              const placaLimpa = this.formData.placa.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
              vei = await db.veiculo.filter(item => {
                const p = (item.veiplaca || item.placa || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                return p === placaLimpa;
              }).first();
            }
            if (vei) {
              await this.validarClienteVeiculo(vei);
            }
          }
        } else {
          if (!this.formData.nomeCliente || this.formData.nomeCliente === "Cliente não encontrado" || this.formData.nomeCliente === "Erro no Banco") {
            this.formData.nomeCliente = "Cliente não encontrado";
          }
        }
      } catch (error) {
        console.error("Erro ao buscar cliente:", error);
        if (!this.formData.nomeCliente) {
          this.formData.nomeCliente = "Erro no Banco";
        }
      }
    },

    async buscarRecebidoPor(valor) {
      const idNum = parseInt(valor);
      if (!valor || isNaN(idNum)) {
        this.formData.nomeRecebidoPor = '';
        this.formData.idRecebidoPor = '';
        this.formData.codRecebidoPor = '';
        return;
      }
      try {
        let tecnico = await db.vendedor.where('vencodigo').equals(idNum).first();
        if (!tecnico) tecnico = await db.vendedor.where('vencodigo').equals(String(idNum)).first();
        if (!tecnico) tecnico = await db.vendedor.where('venidnuvem').equals(idNum).first();
        if (!tecnico) tecnico = await db.vendedor.where('venidnuvem').equals(String(idNum)).first();
        if (!tecnico) tecnico = await db.vendedor.get(idNum);

        if (tecnico) {
          this.formData.nomeRecebidoPor = tecnico.vennome || tecnico.nome || tecnico.descricao;
          this.formData.idRecebidoPor = tecnico.venidnuvem || tecnico.vencodigo || tecnico.id;
          this.formData.codRecebidoPor = tecnico.vencodigo || idNum;
        } else {
          if (!this.formData.nomeRecebidoPor || this.formData.nomeRecebidoPor === "Técnico não encontrado" || this.formData.nomeRecebidoPor === "Erro no Banco") {
            this.formData.nomeRecebidoPor = "Técnico não encontrado";
          }
          this.formData.idRecebidoPor = idNum;
          this.formData.codRecebidoPor = idNum;
        }
      } catch (error) {
        console.error("Erro ao buscar técnico:", error);
        if (!this.formData.nomeRecebidoPor) {
          this.formData.nomeRecebidoPor = "Erro no Banco";
        }
        this.formData.idRecebidoPor = idNum;
        this.formData.codRecebidoPor = idNum;
      }
    },

    async buscarTecnicoVerificacao(valor) {
      const idNum = parseInt(valor);
      if (!valor || isNaN(idNum)) {
        this.formData.nomeTecnicoVerificacao = '';
        this.formData.idTecnicoVerificacao = '';
        this.formData.codTecnicoVerificacao = '';
        return;
      }
      try {
        let tecnico = await db.vendedor.where('vencodigo').equals(idNum).first();
        if (!tecnico) tecnico = await db.vendedor.where('vencodigo').equals(String(idNum)).first();
        if (!tecnico) tecnico = await db.vendedor.where('venidnuvem').equals(idNum).first();
        if (!tecnico) tecnico = await db.vendedor.where('venidnuvem').equals(String(idNum)).first();
        if (!tecnico) tecnico = await db.vendedor.get(idNum);

        if (tecnico) {
          this.formData.nomeTecnicoVerificacao = tecnico.vennome || tecnico.nome || tecnico.descricao;
          this.formData.idTecnicoVerificacao = tecnico.venidnuvem || tecnico.vencodigo || tecnico.id;
          this.formData.codTecnicoVerificacao = tecnico.vencodigo || idNum;
        } else {
          if (!this.formData.nomeTecnicoVerificacao || this.formData.nomeTecnicoVerificacao === "Técnico não encontrado" || this.formData.nomeTecnicoVerificacao === "Erro no Banco") {
            this.formData.nomeTecnicoVerificacao = "Técnico não encontrado";
          }
          this.formData.idTecnicoVerificacao = idNum;
          this.formData.codTecnicoVerificacao = idNum;
        }
      } catch (error) {
        console.error("Erro ao buscar técnico de verificação:", error);
        if (!this.formData.nomeTecnicoVerificacao) {
          this.formData.nomeTecnicoVerificacao = "Erro no Banco";
        }
        this.formData.idTecnicoVerificacao = idNum;
        this.formData.codTecnicoVerificacao = idNum;
      }
    },

    async buscarVendedor(valor) {
      const idNum = parseInt(valor);
      if (!valor || isNaN(idNum)) {
        this.formData.nomeVendedor = '';
        this.formData.idVendedor = '';
        this.formData.codVendedor = '';
        return;
      }
      try {
        let vendedor = await db.vendedor.where('vencodigo').equals(idNum).first();
        if (!vendedor) vendedor = await db.vendedor.where('vencodigo').equals(String(idNum)).first();
        if (!vendedor) vendedor = await db.vendedor.where('venidnuvem').equals(idNum).first();
        if (!vendedor) vendedor = await db.vendedor.where('venidnuvem').equals(String(idNum)).first();
        if (!vendedor) vendedor = await db.vendedor.get(idNum);

        if (vendedor) {
          this.formData.nomeVendedor = vendedor.vennome || vendedor.nome || vendedor.descricao;
          this.formData.idVendedor = vendedor.venidnuvem || vendedor.vencodigo || vendedor.id;
          this.formData.codVendedor = vendedor.vencodigo || idNum;
        } else {
          if (!this.formData.nomeVendedor || this.formData.nomeVendedor === "Vendedor não encontrado" || this.formData.nomeVendedor === "Erro no Banco") {
            this.formData.nomeVendedor = "Vendedor não encontrado";
          }
          this.formData.idVendedor = idNum;
          this.formData.codVendedor = idNum;
        }
      } catch (error) {
        console.error("Erro ao buscar vendedor:", error);
        if (!this.formData.nomeVendedor) {
          this.formData.nomeVendedor = "Erro no Banco";
        }
        this.formData.idVendedor = idNum;
        this.formData.codVendedor = idNum;
      }
    },

    async buscarFornecedor(valor) {
      const idNum = parseInt(valor);
      if (!valor || isNaN(idNum)) {
        this.formData.nomeFornecedor = '';
        this.formData.idFornecedor = '';
        return;
      }
      try {
        let fornecedor = await db.fornecedor.where('foridnuvem').equals(idNum).first();
        if (!fornecedor) fornecedor = await db.fornecedor.where('idfornecedor').equals(idNum).first();
        if (!fornecedor) fornecedor = await db.fornecedor.where('idfornecedor').equals(String(idNum)).first();
        if (!fornecedor) fornecedor = await db.fornecedor.get(idNum);

        if (fornecedor) {
          this.formData.nomeFornecedor = fornecedor.fornome || fornecedor.nome || fornecedor.descricao;
          this.formData.idFornecedor = fornecedor.foridnuvem || fornecedor.idfornecedor || fornecedor.id || idNum;
        } else {
          if (!this.formData.nomeFornecedor || this.formData.nomeFornecedor === "Fornecedor não encontrado" || this.formData.nomeFornecedor === "Erro no Banco") {
            this.formData.nomeFornecedor = "Fornecedor não encontrado";
          }
          this.formData.idFornecedor = idNum;
        }
      } catch (error) {
        console.error("Erro ao buscar fornecedor:", error);
        if (!this.formData.nomeFornecedor) {
          this.formData.nomeFornecedor = "Erro no Banco";
        }
        this.formData.idFornecedor = idNum;
      }
    },

    async buscarVeiculoPorPlacaOS() {
      if (!this.formData.placa || !this.formData.placa.trim()) return;
      const placaLimpa = this.formData.placa.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
      try {
        const vei = await db.veiculo.filter(item => {
          const p = (item.veiplaca || item.placa || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          return p === placaLimpa;
        }).first();
        
        if (vei) {
          this.formData.idveiculo = vei.veiidveiculo || vei.id;
          this.formData.veiculo = vei.veidescricao || vei.descricao || '';
          this.formData.idmarcaveiculo = vei.veiidmarca || vei.IDMARCA || vei.idmarcaveiculo || null;
          if (!this.formData.km) this.formData.km = vei.veikm || vei.km || '';
          if (!this.formData.motor) this.formData.motor = vei.veimotor || vei.motor || '';
          if (!this.formData.ano) this.formData.ano = vei.veiano || vei.ano || '';
          if (!this.formData.modelo) this.formData.modelo = vei.veianomodelo || vei.modelo || '';
          if (!this.formData.combustivel) this.formData.combustivel = vei.veicombustivel || vei.combustivel || '';
          if (!this.formData.chassi) this.formData.chassi = vei.veichassi || vei.chassi || '';

          await this.validarClienteVeiculo(vei);
        } else {
          this.placaNaoEncontrada = this.formData.placa.trim().toUpperCase();
          this.dialogVeiculoNaoEncontrado = true;
        }
      } catch (e) {
        console.warn("Erro ao buscar veículo no Dexie:", e);
      }
    },

    cancelarDialogVeiculoNaoEncontrado() {
      this.dialogVeiculoNaoEncontrado = false;
      this.formData.placa = '';
    },

    confirmarCadastroNovoVeiculo() {
      this.dialogVeiculoNaoEncontrado = false;
      this.abrirCadastroVeiculo();
    },

    async validarClienteVeiculo(vei) {
      if (!vei) return;
      const idClienteOS = this.formData.cliente;
      const idClienteVeiculo = vei.veiidcliente;

      if (idClienteOS && idClienteVeiculo && String(idClienteOS) !== String(idClienteVeiculo)) {
        let nomeClienteVei = '';
        try {
          const cliNum = parseInt(idClienteVeiculo);
          let cli = await db.cliente.where('cliidcliente').equals(cliNum).first();
          if (!cli) cli = await db.cliente.where('cliidcliente').equals(String(idClienteVeiculo)).first();
          if (!cli) cli = await db.cliente.get(cliNum);
          if (cli) {
            nomeClienteVei = cli.clinome || cli.nome || '';
          }
        } catch (e) {
          console.warn("Erro ao carregar cliente do veículo:", e);
        }

        this.veiculoPendenteTrocaCliente = {
          vei,
          placa: vei.veiplaca || vei.placa || this.formData.placa || '',
          descricao: vei.veidescricao || vei.descricao || this.formData.veiculo || '',
          idClienteVeiculo: idClienteVeiculo,
          nomeClienteVeiculo: nomeClienteVei ? `${nomeClienteVei} (Cód: ${idClienteVeiculo})` : `Código ${idClienteVeiculo}`,
          idClienteAtualOS: idClienteOS,
          nomeClienteAtualOS: this.formData.nomeCliente ? `${this.formData.nomeCliente} (Cód: ${idClienteOS})` : `Código ${idClienteOS}`
        };
        this.dialogTrocarClienteVeiculo = true;
      }
    },

    async confirmarTrocaClienteVeiculo() {
      if (this.veiculoPendenteTrocaCliente && this.veiculoPendenteTrocaCliente.vei) {
        const vei = this.veiculoPendenteTrocaCliente.vei;
        const novoClienteId = parseInt(this.formData.cliente) || this.formData.cliente;
        try {
          const targetId = vei.id || vei.veiidveiculo;
          let localItem = await db.veiculo.get(targetId);
          if (!localItem && vei.veiidveiculo) {
            localItem = await db.veiculo.where('veiidveiculo').equals(vei.veiidveiculo).first();
          }
          if (localItem) {
            await db.veiculo.update(localItem.id, { 
              veiidcliente: novoClienteId,
              veidataalteracao: new Date().toISOString()
            });
          }
          vei.veiidcliente = novoClienteId;
        } catch (err) {
          console.error("Erro ao atualizar cliente do veículo no Dexie:", err);
        }
      }
      this.dialogTrocarClienteVeiculo = false;
      this.veiculoPendenteTrocaCliente = null;
    },

    recusarTrocaClienteVeiculo() {
      this.dialogTrocarClienteVeiculo = false;
      this.veiculoPendenteTrocaCliente = null;
    },

    // ==========================================
    // 2. NAVEGAÇÃO E SESSION STORAGE
    // ==========================================
    salvarEstadoTemporario() {
      const estadoAtual = {
        formData: this.formData,
        pedidoDexieId: this.pedidoDexieId,
        itensPedido: this.itensPedido,
        pedidoEnviado: this.pedidoEnviado,
        mostrarObservacao: this.mostrarObservacao
      };
      sessionStorage.setItem('osEmEdicao', JSON.stringify(estadoAtual));
    },

    pesquisarCliente() {
      this.salvarEstadoTemporario();
      this.$router.push({ name: 'clientes', query: { tipo: 'Cliente' } });
    },
    pesquisarRecebidoPor() {
      this.salvarEstadoTemporario();
      this.$router.push({ name: 'vendedor', query: { tipo: 'RecebidoPor' } }); 
    },

    pesquisarTecnicoVerificacao() {
      this.salvarEstadoTemporario();
      this.$router.push({ name: 'vendedor', query: { tipo: 'TecnicoVerificacao' } }); 
    },
    pesquisarVendedor() {
      this.salvarEstadoTemporario();
      this.$router.push({ name: 'vendedor', query: { tipo: 'Vendedor' } });
    },
    pesquisarFornecedor() {
      this.salvarEstadoTemporario();
      this.$router.push({ name: 'fornecedor', query: { tipo: 'Fornecedor' } });
    },
    pesquisarPlaca() {
      this.salvarEstadoTemporario();
      this.$router.push({ name: 'veiculo' });
    },
    abrirCadastroVeiculo() {
      sessionStorage.removeItem('veiculoEmEdicao');
      if (!this.formData.placa || !this.formData.placa.trim()) {
        this.formData.idveiculo = null;
      }
      this.salvarEstadoTemporario();
      this.$router.push({ 
        name: 'cadastroVeiculo', 
        query: { 
          placa: this.formData.placa || '',
          km: this.formData.km || '',
          motor: this.formData.motor || '',
          ano: this.formData.ano || '',
          modelo: this.formData.modelo || '',
          combustivel: this.formData.combustivel || '',
          chassi: this.formData.chassi || ''
        } 
      });
    },
    abrirCadastroEquipamento() {
      this.salvarEstadoTemporario();
      this.$router.push({ 
        name: 'cadastroEquipamento', 
        query: { 
          prsdescricaoequipamento: this.formData.prsdescricaoequipamento || this.formData.descricao || '',
          prsmarcaequipamento: this.formData.prsmarcaequipamento || this.formData.marca || '',
          prsnumeroserieequipamento: this.formData.prsnumeroserieequipamento || this.formData.numSerie || '',
          prsidentificacaoidsequipamento: this.formData.prsidentificacaoidsequipamento || this.formData.ids || '',
          prsdadocomplementar: this.formData.prsdadocomplementar || this.formData.dadosComplementares || '',
          prslivre1: this.formData.prslivre1 || this.formData.campoLivre1 || '',
          prslivre2: this.formData.prslivre2 || this.formData.campoLivre2 || '',
          prslivre3: this.formData.prslivre3 || this.formData.campoLivre3 || '',
          descricao: this.formData.prsdescricaoequipamento || this.formData.descricao || '',
          marca: this.formData.prsmarcaequipamento || this.formData.marca || '',
          numSerie: this.formData.prsnumeroserieequipamento || this.formData.numSerie || '',
          ids: this.formData.prsidentificacaoidsequipamento || this.formData.ids || '',
          dadosComplementares: this.formData.prsdadocomplementar || this.formData.dadosComplementares || '',
          campoLivre1: this.formData.prslivre1 || this.formData.campoLivre1 || '',
          campoLivre2: this.formData.prslivre2 || this.formData.campoLivre2 || '',
          campoLivre3: this.formData.prslivre3 || this.formData.campoLivre3 || ''
        } 
      });
    },

    async verificarRetornoPesquisa() {
      this.isRestaurando = true;
      const estadoSalvo = sessionStorage.getItem('osEmEdicao');
      
      if (estadoSalvo) {
        const estado = JSON.parse(estadoSalvo);
        this.formData = { ...this.formData, ...estado.formData };
        this.pedidoDexieId = estado.pedidoDexieId;
        this.pedidoEnviado = estado.pedidoEnviado || false;
        
        if (estado.mostrarObservacao !== undefined) {
          this.mostrarObservacao = estado.mostrarObservacao;
        } else if (this.formData.observacao && this.formData.observacao.trim() !== '') {
          this.mostrarObservacao = true;
        }
        
        if (estado.itensPedido && estado.itensPedido.length > 0) {
          this.itensPedido = estado.itensPedido; 
        }
      }

      const idVinculoNovo = sessionStorage.getItem('idPedidoVinculoAtual');
      if (idVinculoNovo) {
        if (!this.formData.prslinkpedidoitem) {
          this.formData.prslinkpedidoitem = idVinculoNovo;
        }
        sessionStorage.removeItem('idPedidoVinculoAtual');
      }

      const eqRetorno = sessionStorage.getItem('equipamento_selecionado_retorno');
      if (eqRetorno) {
        try {
          const eq = JSON.parse(eqRetorno);
          if (eq.prsdescricaoequipamento !== undefined) this.formData.prsdescricaoequipamento = eq.prsdescricaoequipamento;
          if (eq.prsmarcaequipamento !== undefined) this.formData.prsmarcaequipamento = eq.prsmarcaequipamento;
          if (eq.prsnumeroserieequipamento !== undefined) this.formData.prsnumeroserieequipamento = eq.prsnumeroserieequipamento;
          if (this.formData.prsnumeroserieequipamento) this.formData.numSerie = this.formData.prsnumeroserieequipamento;
          if (eq.prsidentificacaoidsequipamento !== undefined) this.formData.prsidentificacaoidsequipamento = eq.prsidentificacaoidsequipamento;
          if (eq.prsdadocomplementar !== undefined) this.formData.prsdadocomplementar = eq.prsdadocomplementar;
          if (eq.prslivre1 !== undefined) this.formData.prslivre1 = eq.prslivre1;
          if (eq.prslivre2 !== undefined) this.formData.prslivre2 = eq.prslivre2;
          if (eq.prslivre3 !== undefined) this.formData.prslivre3 = eq.prslivre3;
          sessionStorage.removeItem('equipamento_selecionado_retorno');
        } catch (e) {
          console.error('Erro ao ler equipamento_selecionado_retorno:', e);
        }
      }

      const retorno = sessionStorage.getItem('pesquisaResultado');
      if (retorno) {
        try {
          const res = JSON.parse(retorno);
          
          if (res.tipo === 'Cliente') {
            this.formData.cliente = res.codigo;
            this.formData.nomeCliente = res.descricao;
          } else if (res.tipo === 'RecebidoPor') {
            await this.buscarVendedorPorIdNuvem('RecebidoPor', res.codigo);
          } else if (res.tipo === 'TecnicoVerificacao') {
            await this.buscarVendedorPorIdNuvem('TecnicoVerificacao', res.codigo);
          } else if (res.tipo === 'Vendedor') {
            await this.buscarVendedorPorIdNuvem('Vendedor', res.codigo);
          } else if (res.tipo === 'Fornecedor') {
            this.formData.idFornecedor = res.codigo;
            this.formData.nomeFornecedor = res.descricao; 
          } else if (res.tipo === 'Veiculo') {
            let vei = null;
            if (res.dexieId) {
              vei = await db.veiculo.get(parseInt(res.dexieId));
            }
            if (!vei && (res.id || res.idveiculo)) {
              const idVei = parseInt(res.id || res.idveiculo);
              if (!isNaN(idVei)) {
                vei = await db.veiculo.where('veiidveiculo').equals(idVei).first()
                  || await db.veiculo.get(idVei);
              }
            }
            if (!vei && (res.placa || res.codigo)) {
              const placaLimpa = String(res.placa || res.codigo).trim().toLowerCase().replace(/[^a-z0-9]/g, '');
              vei = await db.veiculo.filter(item => {
                const p = (item.veiplaca || item.placa || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                return p === placaLimpa;
              }).first();
            }

            if (vei) {
              this.formData.placa = vei.veiplaca || vei.placa || res.placa || res.codigo || '';
              this.formData.veiculo = vei.veidescricao || vei.descricao || res.descricao || res.nome || '';
              this.formData.km = vei.veikm || vei.km || res.km || '';
              this.formData.motor = vei.veimotor || vei.motor || res.motor || '';
              this.formData.ano = vei.veiano || vei.ano || res.ano || '';
              this.formData.modelo = vei.veianomodelo || vei.modelo || res.modelo || res.veianomodelo || '';
              this.formData.combustivel = vei.veicombustivel || vei.combustivel || res.combustivel || '';
              this.formData.chassi = vei.veichassi || vei.chassi || res.chassi || '';
              this.formData.idveiculo = vei.veiidveiculo || vei.id;
              await this.validarClienteVeiculo(vei);
            } else {
              this.formData.placa = res.placa || res.codigo || '';
              this.formData.veiculo = res.descricao || res.nome || '';
              this.formData.idveiculo = res.id || res.idveiculo || null;
              this.formData.km = res.km || '';
              this.formData.motor = res.motor || '';
              this.formData.ano = res.ano || '';
              this.formData.modelo = res.modelo || res.veianomodelo || '';
              this.formData.combustivel = res.combustivel || '';
              this.formData.chassi = res.chassi || '';
            }
          }
          
          sessionStorage.removeItem('pesquisaResultado');
        } catch (error) {
          console.error('Erro ao ler sessionStorage:', error);
        }
      }

      if (this.formData.placa && !this.formData.idveiculo) {
        const placaLimpa = this.formData.placa.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
        const vei = await db.veiculo.filter(item => {
          const p = (item.veiplaca || item.placa || '').toLowerCase().replace(/[^a-z0-9]/g, '');
          return p === placaLimpa;
        }).first();
        if (vei) {
          this.formData.idveiculo = vei.veiidveiculo || vei.id;
          this.formData.veiculo = vei.veidescricao || vei.descricao || this.formData.veiculo;
          this.formData.km = vei.veikm || vei.km || this.formData.km;
          this.formData.motor = vei.veimotor || vei.motor || this.formData.motor;
          this.formData.ano = vei.veiano || vei.ano || this.formData.ano;
          this.formData.modelo = vei.veianomodelo || vei.modelo || this.formData.modelo;
          this.formData.combustivel = vei.veicombustivel || vei.combustivel || this.formData.combustivel;
          this.formData.chassi = vei.veichassi || vei.chassi || this.formData.chassi;

          await this.validarClienteVeiculo(vei);
        }
      }

      if (this.formData.prslinkpedidoitem || this.pedidoDexieId) {
        await this.carregarItens();
      }

      this.$nextTick(() => {
        this.isRestaurando = false;
      });
    },

    // ==========================================
    // 3. CRUD (SALVAR, CANCELAR, EXCLUIR)
    // ==========================================

    async salvar() {
      this.camposInvalidos = [];

      if (!this.formData.cliente || 
          !this.formData.nomeCliente || 
          ['Cliente não encontrado', 'Erro no Banco'].includes(this.formData.nomeCliente)) {
        this.camposInvalidos.push('Cliente');
      }

      if (!this.formData.idRecebidoPor || 
          !this.formData.nomeRecebidoPor || 
          ['Técnico não encontrado', 'Erro no Banco'].includes(this.formData.nomeRecebidoPor)) {
        this.camposInvalidos.push('Recebido Por');
      }

      if (this.exibirSecaoTecnicoVerificacao) {
        if (!this.formData.idTecnicoVerificacao || 
            !this.formData.nomeTecnicoVerificacao || 
            ['Técnico não encontrado', 'Erro no Banco'].includes(this.formData.nomeTecnicoVerificacao)) {
          this.camposInvalidos.push('Técnico Verificação');
        }
      }

      if (this.formData.idFornecedor && 
          ['Fornecedor não encontrado', 'Erro no Banco'].includes(this.formData.nomeFornecedor)) {
        this.camposInvalidos.push('Fornecedor (Indicação)');
      }


      if (this.camposInvalidos.length > 0) {
        this.dialogValidacao = true;
        return;
      }

      this.isSalvando = true;

      try {
        let dataComHora = this.formData.dataAbertura;
        
        if (dataComHora && dataComHora.length === 10) {
          const agora = new Date();
          const hora = agora.getHours().toString().padStart(2, '0');
          const minuto = agora.getMinutes().toString().padStart(2, '0');
          const segundo = agora.getSeconds().toString().padStart(2, '0');
          dataComHora = `${dataComHora}T${hora}:${minuto}:${segundo}`;
        }

        const idUsuarioNuvem = sessionStorage.getItem(USER_STORAGE.useidnuvem);
        let idEmpresa = sessionStorage.getItem('empidempresa');
        if (!idEmpresa || idEmpresa === 'null' || idEmpresa === 'undefined') {
          const empresaLocal = await db.empresa.toCollection().first();
          if (empresaLocal) {
            idEmpresa = empresaLocal.idempresa || empresaLocal.empidempresa || empresaLocal.empidnuvem;
            if (idEmpresa) {
              sessionStorage.setItem('empidempresa', idEmpresa);
            }
          }
        }

        let idVeiculoSalvar = this.formData.idveiculo ? parseInt(this.formData.idveiculo) : null;
        let idMarcaVeiculoSalvar = this.formData.idmarcaveiculo ? parseInt(this.formData.idmarcaveiculo) : null;
        
        let veiRef = null;
        if (idVeiculoSalvar) {
          veiRef = await this.obterVeiculoPorId(idVeiculoSalvar);
        }
        if (!veiRef && this.formData.placa) {
          const placaLimpa = this.formData.placa.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
          veiRef = await db.veiculo.filter(item => {
            const p = (item.veiplaca || item.placa || '').toLowerCase().replace(/[^a-z0-9]/g, '');
            return p === placaLimpa;
          }).first();
          if (veiRef) {
            idVeiculoSalvar = veiRef.veiidveiculo || veiRef.id;
          }
        }

        if (!idMarcaVeiculoSalvar && veiRef) {
          idMarcaVeiculoSalvar = veiRef.veiidmarca || veiRef.IDMARCA || veiRef.idmarcaveiculo || null;
        }

        const parseId = (val1, val2) => {
          if (val1 !== '' && val1 !== null && val1 !== undefined && !isNaN(parseInt(val1))) return parseInt(val1);
          if (val2 !== '' && val2 !== null && val2 !== undefined && !isNaN(parseInt(val2))) return parseInt(val2);
          return null;
        };

        const osData = {
          prsidcliente: this.formData.cliente ? parseInt(this.formData.cliente) : null,
          prsnomecliente: this.formData.nomeCliente,
          prsidvendedor: parseId(this.formData.idVendedor, this.formData.codVendedor),
          prsidfornecedor: parseId(this.formData.idFornecedor, null),
          prsrecebidopor: parseId(this.formData.idRecebidoPor, this.formData.codRecebidoPor), 
          prsidtecnicoverificacao: parseId(this.formData.idTecnicoVerificacao, this.formData.codTecnicoVerificacao), 
          prstipo: 1,
          prsidusuario: idUsuarioNuvem ? parseInt(idUsuarioNuvem) : null,
          prsidempresa: idEmpresa ? parseInt(idEmpresa) : null,

          prsidveiculo: idVeiculoSalvar,
          prsidmarcaveiculo: idMarcaVeiculoSalvar,
          prskm: this.formData.km || null,
          prsmotor: this.formData.motor || null,
          prsanoveiculo: this.formData.ano || null,
          prsanomodeloveiculo: this.formData.modelo || null,
          prscombustivel: this.formData.combustivel || null,
          prsnumerochassi: this.formData.chassi || null,
          prsnumeroserieequipamento: this.formData.prsnumeroserieequipamento || this.formData.numSerie || null,
          prsdescricaoequipamento: this.formData.prsdescricaoequipamento || null,
          prsmarcaequipamento: this.formData.prsmarcaequipamento || null,
          prsidentificacaoidsequipamento: this.formData.prsidentificacaoidsequipamento || null,
          prsdadocomplementar: this.formData.prsdadocomplementar || null,
          prslivre1: this.formData.prslivre1 || null,
          prslivre2: this.formData.prslivre2 || null,
          prslivre3: this.formData.prslivre3 || null,

          prsdatatransmissao: null,
          status: 'Abertas',
          
          prsdefeito: this.formData.defeitoApresentado,
          prsobservacao: this.mostrarObservacao ? this.formData.observacao : '',
          
          prsnumeroos: this.formData.nroOS,
          itensPedido: JSON.parse(JSON.stringify(this.itensPedido)),
          prslinkpedidoitem: this.formData.prslinkpedidoitem,
        };


        if (this.pedidoDexieId) {
          osData.prsdataalteracao = geraData();
          osData.prsidvendedoralteracao = idUsuarioNuvem ? parseInt(idUsuarioNuvem) : null;
          
          await db.prestacaoservico.update(this.pedidoDexieId, osData);

        } else {
          osData.prsdatainclusao = dataComHora;
          osData.prsdataalteracao = null; 

          const novoId = await db.prestacaoservico.add(osData);
          this.pedidoDexieId = novoId;
        }

        if (this.formData.prslinkpedidoitem) {
          try {
            await db.prestacaoservicoitem
              .where('prilinkpedidoitem')
              .equals(this.formData.prslinkpedidoitem)
              .modify({ idprestacaoservico: this.pedidoDexieId });
          } catch(e) { 
            console.error("[SALVAR] ERRO ao vincular itens:", e); 
          }
        }

        if (this.formData.prslinkpedidoitem) {
          try {
            await db.prestacaoservicoitem
              .where('prilinkpedidoitem')
              .equals(this.formData.prslinkpedidoitem)
          } catch(e) {
            console.error('Erro ao marcar itens como enviados:', e);
          }
        }
        
        const imgs = this.arquivosTemp['OS_MEDIA'];
        try {
          const imagensDB = await db.imagem.where('relacaoidlocal').equals(this.pedidoDexieId).filter(img => img.relacao === 'prestacaoservico').toArray();
          if (imagensDB && imagensDB.length > 0) {
            const imagensAtuais = (imgs || []).map(img => img.nomearquivo);
            for (const imgDB of imagensDB) {
              if (!imagensAtuais.includes(imgDB.nomearquivo)) {
                await db.imagem.delete(imgDB.id);
              }
            }
          }
        } catch (err) {
          // console.error("[SALVAR] Erro ao limpar imagens antigas:", err);
        }

        if (imgs && imgs.length > 0) {
          for (const img of imgs) {
            if (!img.datacriacao) {
              await db.imagem.add({
                datacriacao: geraData(),
                relacao: 'prestacaoservico',
                relacaoidlocal: this.pedidoDexieId,
                blob: img.blob,
                nomearquivo: img.blob?.name,
                rotaapi: '/imagem/prestacaoservico',
                tipo: img.blob?.type?.split('/'),
              });
            }
          }
        }

        sessionStorage.removeItem('osEmEdicao');
        sessionStorage.removeItem('pesquisaResultado');
        sessionStorage.removeItem('idPedidoVinculoAtual');

        setTimeout(() => {
          this.$set(this.arquivosTemp, 'OS_MEDIA', []);
        }, 500);

        
        this.$router.push({ name: 'prestacaoservico' }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
        

      } catch (error) {
        // console.error("[SALVAR] ERRO FATAL no catch principal:", error);
        // alert("Erro ao salvar a O.S. Verifique o console para mais detalhes.");
      } finally {
        setTimeout(() => {
          this.isSalvando = false;
        }, 500);
      }
    },

    excluir() {
      if (!this.pedidoDexieId) return;
      this.dialogConfirmarExclusao = true;
    },

    async confirmarExclusao() {
      try {
        await db.prestacaoservico.delete(this.pedidoDexieId);

        
        sessionStorage.removeItem('osEmEdicao');
        sessionStorage.removeItem('pesquisaResultado');

        this.$set(this.arquivosTemp, 'OS_MEDIA', []);

        this.dialogConfirmarExclusao = false;
        this.$router.back();
      } catch (error) {
        console.error("Erro ao excluir:", error);
        alert("Erro ao excluir a O.S.");
      }
    },

    cancelar() {
      if (this.pedidoEnviado) {
        this.confirmarCancelamento();
        return;
      }

      const temDadosPreenchidos = 
        this.formData.cliente !== '' || 
        this.formData.idRecebidoPor !== '' || 
        this.formData.idVendedor !== '' || 
        this.formData.idFornecedor !== '' || 
        (this.formData.placa && this.formData.placa.trim() !== '') ||
        (this.formData.defeitoApresentado && this.formData.defeitoApresentado.trim() !== '') ||
        this.itensPedido.length > 0;

      if (temDadosPreenchidos) {
        this.dialogConfirmarCancelamento = true;
      } else {
        this.confirmarCancelamento();
      }
    },

    async confirmarCancelamento() {
      if (this.formData.prslinkpedidoitem) {
        try {
          const todosItens = await db.prestacaoservicoitem
            .where('prilinkpedidoitem')
            .equals(this.formData.prslinkpedidoitem)
            .toArray();

          const itensNaoSalvos = todosItens.filter(item => !item.idprestacaoservico);

          if (itensNaoSalvos.length > 0) {
            const idsParaLimpar = itensNaoSalvos.map(i => i.id);
            
            await db.prestacaoservicoitem.bulkDelete(idsParaLimpar);
          }
        } catch (e) {
          console.error('Erro ao limpar itens ao cancelar:', e);
        }
      }

      sessionStorage.removeItem('osEmEdicao');
      sessionStorage.removeItem('pesquisaResultado');
      
      this.$set(this.arquivosTemp, 'OS_MEDIA', []);

      this.dialogConfirmarCancelamento = false;
      this.$router.back(); 
    },

    // ==========================================
    // 4. OUTROS MÉTODOS MANTIDOS
    // ==========================================
    adicionarItem() {
      const isClienteInvalido = !this.formData.cliente || !this.formData.nomeCliente || ['Cliente não encontrado', 'Erro no Banco'].includes(this.formData.nomeCliente);
      
      if (isClienteInvalido) {
        this.dialogClienteObrigatorio = true;
        return;
      }

      if (!this.formData.prslinkpedidoitem) {
        this.formData.prslinkpedidoitem = 'OS-' + Date.now().toString() + Math.floor(Math.random() * 1000);
      }

      this.salvarEstadoTemporario();
      
      this.$router.push({ 
        name: 'CadastroItem',
        query: { 
          prslinkpedidoitem: this.formData.prslinkpedidoitem
        }
      });
    },

    async carregarItens() {
      if (!this.pedidoDexieId && !this.formData.prslinkpedidoitem) return;
      
      try {
        const link = this.formData.prslinkpedidoitem;
        const localId = this.pedidoDexieId;
        
        let prsidnuvem = null;
        if (localId) {
          const os = await db.prestacaoservico.get(localId);
          if (os) {
            prsidnuvem = os.prsidnuvem;
          }
        }

        const itens = await db.prestacaoservicoitem.filter(i => {
          const matchLink = link && i.prilinkpedidoitem === link;
          const matchLocalId = localId && i.idprestacaoservico === localId;
          const matchNuvem = prsidnuvem && i.priidprestacaoserviconuvem && String(i.priidprestacaoserviconuvem) === String(prsidnuvem);
          return matchLink || matchLocalId || matchNuvem;
        }).toArray();

        this.itensPedido = await Promise.all(itens.map(async item => {
          const qtd = parseFloat(item.priquantidade) || 1;
          const valor = parseFloat(item.privalor) || 0;

          let isServico = false;
          if (item.priidproduto) {
            try {
              const codProd = parseInt(item.priidproduto);
              let prod = null;
              if (!isNaN(codProd)) {
                prod = await db.produto.where('proidcortamanhofinal').equals(codProd).first();
              }
              if (!prod) {
                prod = await db.produto.where('proidcortamanhofinal').equals(String(item.priidproduto)).first();
              }
              if (!prod && !isNaN(codProd)) {
                prod = await db.produto.get(codProd);
              }

              if (prod && prod.proidcategoriaproduto !== undefined && prod.proidcategoriaproduto !== null) {
                const catId = parseInt(prod.proidcategoriaproduto);
                let cat = null;
                if (!isNaN(catId)) {
                  cat = await db.categoria.where('catidcategoria').equals(catId).first();
                }
                if (!cat) {
                  cat = await db.categoria.where('catidcategoria').equals(String(prod.proidcategoriaproduto)).first();
                }
                if (!cat && !isNaN(catId)) {
                  cat = await db.categoria.get(catId);
                }

                if (cat) {
                  isServico = (cat.catservico === 1 || cat.catservico === true || String(cat.catservico).toUpperCase() === 'S' || String(cat.catservico) === '1');
                } else {
                  isServico = (parseInt(item.priidgrupo) === 2 || parseInt(item.idgrupo) === 2);
                }
              } else {
                isServico = (parseInt(item.priidgrupo) === 2 || parseInt(item.idgrupo) === 2);
              }
            } catch (err) {
              console.error("Erro ao buscar categoria do produto para o item:", item, err);
              isServico = (parseInt(item.priidgrupo) === 2 || parseInt(item.idgrupo) === 2);
            }
          } else {
            isServico = (parseInt(item.priidgrupo) === 2 || parseInt(item.idgrupo) === 2);
          }

          const obj = {
            id: item.id || item.idprestacaoservicoitem,
            codigo: item.priidproduto, 
            descricao: item.pridescricao || item.nomeProduto || `Cód. ${item.priidproduto || 'S/N'}`, 
            quantidade: qtd,
            valorunitario: valor,
            valordesconto: parseFloat(item.pridesconto) || 0,
            vlrpromocaoclube: parseFloat(item.vlrpromocaoclube) || 0,
            subtotal: item.pritotal || (qtd * valor),
            observacao: item.priobservacao || '',
            idgrupo: parseInt(item.priidgrupo) || parseInt(item.idgrupo) || null,
            isServico: isServico,
          };

          return obj;
        }));

      } catch (error) {
        console.error("Erro ao carregar itens da O.S.:", error);
      }
    },
    
    editarItem(item) {
      this.salvarEstadoTemporario();
      
      this.$router.push({ 
        name: 'CadastroItem',
        query: { 
          prslinkpedidoitem: this.formData.prslinkpedidoitem,
          idItem: item.id
        }
      });
    },

    abrirAdicionarMidia() {
      if (!this.arquivosTemp['OS_MEDIA']) {
        this.$set(this.arquivosTemp, 'OS_MEDIA', []);
      }
      this.imagemDialog = true;
      window.location.hash = '#imagem';
    },

    fecharAdicionarMidia() {
      this.imagemDialog = false;
      this.$router.replace({
        path: this.$route.path,
        query: this.$route.query,
      }).catch(() => {});
    },

    $_onGerenciadorAtualizar(midias) {
      this.$set(this.arquivosTemp, 'OS_MEDIA', midias || []);
    },

    async $_iniciarCamera() {
      this.$router.replace({
        path: this.$route.path,
        query: this.$route.query,
      }).catch(() => {});
      
      let refId = this.pedidoDexieId;
      if (!refId && this.formData.prslinkpedidoitem) refId = this.formData.prslinkpedidoitem;

      this.$router.push({
        ...this.$route,
        name: ROUTE_CAMERA.name,
        params: { tipo: 'prestacaoservico', id: refId }
      });
    },

    $_abrirMidiaModal(index) {
      this.indiceMidiaModal = index;
      this.midiaModal = this.arquivosTemp['OS_MEDIA'] ? this.arquivosTemp['OS_MEDIA'][index] : null;
      this.midiaModalAberto = true;
      window.location.hash = "#midia";

      this.$nextTick(() => {
        if (this.$refs.videoFullscreen && this.midiaModal && this.midiaModal.tipo === 'video') {
          this.$refs.videoFullscreen.pause();
        }
      });
    },

    $_fecharMidiaModal() {
      if (this.$refs.videoFullscreen && this.midiaModal.tipo === 'video') {
        this.$refs.videoFullscreen.pause();
        this.$refs.videoFullscreen.currentTime = 0;
      }
      this.midiaModalAberto = false;
      window.location.hash = '#imagens'
      this.midiaModal = null;
      this.indiceMidiaModal = null;
    },
    
    formatarValor(valor) {
      if (!valor) return '0,00';
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  },

  watch: {
    formData: {
      handler() {
        if (!this.isRestaurando) {
          this.salvarEstadoTemporario();
        }
      },
      deep: true
    },
    itensPedido: {
      handler() {
        if (!this.isRestaurando) {
          this.salvarEstadoTemporario();
        }
      },
      deep: true
    },

    'formData.cliente'(novo) { 
      if (!this.isRestaurando) {
        if (novo) {
          this.buscarCliente(novo);
        } else {
          this.formData.nomeCliente = '';
        }
      }
    },
    'formData.codRecebidoPor'(novo) {
      if (!this.isRestaurando) {
        if (novo) {
          this.buscarRecebidoPor(novo);
        } else {
          this.formData.nomeRecebidoPor = '';
          this.formData.idRecebidoPor = '';
        }
      }
    },
    'formData.codTecnicoVerificacao'(novo) {
      if (!this.isRestaurando) {
        if (novo) {
          this.buscarTecnicoVerificacao(novo);
        } else {
          this.formData.nomeTecnicoVerificacao = '';
          this.formData.idTecnicoVerificacao = '';
        }
      }
    },
    'formData.codVendedor'(novo) {
      if (!this.isRestaurando) {
        if (novo) {
          this.buscarVendedor(novo);
        } else {
          this.formData.nomeVendedor = '';
          this.formData.idVendedor = '';
        }
      }
    },
    'formData.idFornecedor'(novo) {
      if (!this.isRestaurando) {
        if (novo) {
          this.buscarFornecedor(novo);
        } else {
          this.formData.nomeFornecedor = '';
        }
      }
    },
    mostrarObservacao() {
      if (!this.isRestaurando) {
        this.salvarEstadoTemporario();
      }
    },
  }
}
</script>

<style scoped>
.formulario-wrapper {
  background-color: #f5f5f5;
  padding: 32px 16px;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.lista-itens-container {
  max-height: 400px; 
  border: 1px solid #eee;
  border-radius: 4px;
}

.lista-itens-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}

.lista-itens-container ::v-deep .simplebar-track.simplebar-horizontal {
  height: 10px !important;
}

.v-cardt{
  padding-top: 5px;
}

.v-card {
  max-width: 900px;
  width: 100%;
}

.v-subheader {
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  margin-top: 8px;
}

.v-form .v-row {
  margin-bottom: 4px;
}

.col-codigo {
  flex: 0 0 25%;
  max-width: 25%;
}
.col-botao {
  flex: 0 0 8.3333333333%;
  max-width: 8.3333333333%;
}
.col-descricao {
  padding-left: 18px;
  flex: 0 0 66.6666666667%;
  max-width: 66.6666666667%;
}

.lista-itens-container ::v-deep .simplebar-scrollbar::before {
  background: rgba(76, 111, 175, 0.4) !important;
}

.lista-itens-container ::v-deep .simplebar-track.simplebar-horizontal {
  height: 10px !important;
}

.switch-pedido-ativo ::v-deep .v-input--switch__track {
  color: #9dafd1 !important;
  opacity: 0.6;
}

.formulario-wrapper {
  max-width: 560px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.switch-pedido-ativo ::v-deep .v-input--switch__thumb {
  color: #4c6faf !important;
}

.switch-pedido-ativo ::v-deep .v-input--selection-controls__ripple {
  color: #728ec2 !important;
}

::v-deep .v-text-field--outlined .v-input__control .v-input__slot {
  min-height: 40px !important;
}

.divisor-secao {
  border-top: 1px solid #5a5a5a !important;
  border-color: #5a5a5a !important;
  opacity: 0.95;
}

.teste{
  background-color: #4c6faf;
}

</style>